module.exports = __webpack_public_path__ + "img/Airbnb-Equipment-Screens-Main-Page.b0536c3b.jpg";